import { render, staticRenderFns } from "./version-management.vue?vue&type=template&id=5317f333&scoped=true"
import script from "./version-management.ts?vue&type=script&lang=ts&external"
export * from "./version-management.ts?vue&type=script&lang=ts&external"
import style0 from "./version-management.less?vue&type=style&index=0&id=5317f333&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317f333",
  null
  
)

export default component.exports